import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/index';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: './party-bcc-bsa.component.html',
    standalone: false
})
export class InstallationPartyBccBsaPluginComponent {
  public bccBsa: any;
  public config: any;
  public editRoute = ['installation', 'partybccbsa', 'edit'];

  constructor(private cdRef: ChangeDetectorRef, private translateService: TranslateService) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  hasValue() {
    return (
      this.bccBsa?.BobstBSF === true ||
      this.bccBsa?.BobstBCC === true ||
      this.bccBsa?.BobstAgent === true ||
      this.bccBsa?.Customer === true ||
      this.bccBsa?.ThirdParty === true ||
      this.bccBsa?.NA === true
    );
  }

  getProvenanceText() {
    const provenances = [];

    if (this.bccBsa?.BobstBSF === true)
      provenances.push(this.translateService.instant('plugins.installationpartybccbsa.bobst-bsf'));
    if (this.bccBsa?.BobstBCC === true)
      provenances.push(this.translateService.instant('plugins.installationpartybccbsa.bobst-bcc'));
    if (this.bccBsa?.BobstAgent === true)
      provenances.push(this.translateService.instant('plugins.installationpartybccbsa.bobst-agent'));
    if (this.bccBsa?.Customer === true)
      provenances.push(this.translateService.instant('plugins.installationpartybccbsa.customer'));
    if (this.bccBsa?.ThirdParty === true)
      provenances.push(this.translateService.instant('plugins.installationpartybccbsa.third-party'));
    if (this.bccBsa?.NA === true)
      provenances.push(this.translateService.instant('plugins.installationpartybccbsa.non-applicable'));

    return provenances.join(', ');
  }

  private initData() {
    this.bccBsa = this.config.PartyBccBsa;
  }
}
PluginComponent.plugins['installationpartybccbsa'] = InstallationPartyBccBsaPluginComponent;
